import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { generateToken, messaging } from '../notifications/firebase';
import { onMessage } from 'firebase/messaging';
import { AnimatePresence } from 'framer-motion';

const LoggedInLayout: React.FC = () => {

  useEffect(() => {
    generateToken();
    onMessage(messaging, (payload) => {
      console.log(payload)
    })
  }, [])

  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-r from-customBg via-customBg2 to-customBg/80">
      <Header />
      <div className="flex-1 pt-2 pb-16">
        <AnimatePresence mode="wait">
          <Outlet />
        </AnimatePresence>
      </div>
      <Footer />
    </div>
  );
};

export default LoggedInLayout;
